import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { LogRocketService } from './logrocket.service';

export function provideLogRocket(enabled?: boolean, appId?: string): EnvironmentProviders[] {
  return enabled && appId
    ? [
      provideAppInitializer(() => inject(LogRocketService).initialize(appId)),
    ]
    : [];
}
